<template>
  <div class="HelpContent">
    <!-- 如何下载安装电子书？ -->
    <div class="section help1">
      <h3>
        如何下载安装电子书？
        <span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4>一、Android用户</h4>
      <div class="paragraph1">
        1. 打开手机的浏览器，在地址栏输入：ebook.pep.com.cn/ry，并打开网页；
        <br />
        2. 在打开的页面内，通过点击“立即下载”按钮来下载电子书安装程序；
        <br />
        3. 下载完成后，打开安装包，点击“安装”。
      </div>
      <h4>二、iOS用户</h4>
      <div class="paragraph1">
        1. 打开App Store，选择“搜索”选项；<br />
        2. 输入“标准日本语”，并进行搜索；<br />
        3. 找到并打开“《标准日本语》电子书”，点击“免费”进行安装。
      </div>
    </div>
    <!-- 如何激活电子书？ -->
    <div class="section help2">
      <h3>
        如何激活电子书？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4>新用户（在注册时激活电子书）：</h4>
      <div class="paragraph1">
        1. 刮开图书封底的激活码涂层获取激活码；<br />
        2. 下载、安装电子书；<br />
        3.
        启动电子书，在注册过程中根据提示输入激活码，选择电子书（初级、中级或高级）并
        <br />&nbsp;&nbsp;&nbsp;激活。
      </div>
      <h4>已注册用户：</h4>
      <div class="paragraph1">
        1. 刮开图书封底的激活码涂层获取激活码；<br />
        2. 确认已经下载安装电子书、且已经注册并登录；<br />
        3. 在电子书主界面点击右上角“设置”按钮->“资源管理”项；<br />
        4. 选择电子书（初级、中级或高级），根据提示输入激活码并激活。
      </div>
    </div>
    <!-- 如果选错书了怎么办？ -->
    <div class="section help3">
      <h3>
        如果选错书了怎么办？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        在首次使用激活码成功激活电子书7天内，如发现选错了书，可以重新激活并再选一次电子书（仅此一次机会），操作如下：
      </h4>
      <div class="paragraph1">
        1. 在电子书主界面点击右上角的“设置”按钮->“资源管理”项；<br />
        2. 在被错误激活的图书下方，点击“重新激活”按钮；<br />
        3. 按照提示选择正确的图书激活即可。
      </div>
    </div>
    <!-- 如何获得激活码？ -->
    <div class="section help4">
      <h3>
        如何获得激活码？<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        购买正版图书即可随书得到一个激活码（如图），其已附在第二版《新版
        中日交流标准日本语》纸质图书封底（刮开涂层即是）。
      </h4>
      <div class="img-wrap">
        <img
          src="@/assets/images/14ry_tp04.jpg"
          alt=""
          width="352"
          height="408"
        />
      </div>
    </div>
    <!-- 更多问题请关注微信。 -->
    <div class="section help5">
      <h3>
        更多问题请关注微信。<span class="toTop" @click="toTop()">[To Top]</span>
      </h3>
      <h4 style="text-indent: 2em">
        如果您在使用“标日电子书”的过程中，遇到其他其问题，欢迎通过我们的官方微信“XueBiaoRi”中的“微客服”提交，我们会有专人为您解决。关注微信后，您还可以获得“标日”相关的最新信息、学习资料以及参与我们的有奖活动等。
      </h4>
      <div class="img-wrap">
        <img src="@/assets/images/14br_q5.jpg" alt="" width="400" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    "$route.params": {
      handler(newVl) {
        console.log(newVl);
        this.scrollToAnchor(newVl)
      },
      deep: true,
    },
  },
  mounted() {
    this.scrollToAnchor(this.$route.params)
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    scrollToAnchor({anchor}) {
      let selector = "." + anchor;
      let element = document.querySelector(selector);
      if (!element) return
        this.$nextTick(() => {
          window.scrollTo({
            top: element.offsetTop,
            behavior: "smooth",
          });
        });
    },
  },
};
</script>
